export default __webpack_public_path__ + "static/brand-presentation-builder-70c9ea552f78a542d1f3de6ece0d7d17.svg";